<template>
  <div class="dp-accordion" :class="{ 'dp-accordion--open': isOpen && isKeyboardOpen }">
    <button
      type="button"
      class="dp-accordion__button btn btn-link d-flex align-items-center w-100 p-3 text-left"
      :aria-expanded="isOpen ? 'true' : 'false'"
      :aria-controls="uid"
      @click="toggle($event)"
    >
      <span class="dp-accordion__title flex-grow-1 font-weight-bold">{{ title }}</span>
      <span
        class="dp-accordion__chevron d-inline-flex align-items-center justify-content-center flex-shrink-0 ml-2"
        :class="{ 'dp-accordion__chevron--open': isOpen }"
        aria-hidden="true"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 4.5L6 8.5L10 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
    </button>

    <b-collapse :id="uid" :visible="isOpen">
      <div class="dp-accordion__body px-3 pb-3">
        <slot />
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'DpAccordion',
  props: {
    title: {
      type: String,
      required: true,
    },
    initiallyOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    accordionId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isOpen: this.initiallyOpen,
      isKeyboardOpen: false,
      uid: this.accordionId || `dp-accordion-${this._uid}`,
    };
  },
  methods: {
    toggle(event) {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        // event.detail is 0 for keyboard-triggered clicks, ≥1 for pointer clicks
        this.isKeyboardOpen = event.detail === 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables';

.dp-accordion {
  background-color: $dp-white;
  border: 1px solid $neutral-200;
  border-radius: 8px;
  overflow: hidden;

  &:has(.dp-accordion__button:focus-visible) {
    background-color: $cyan-200;
    border-color: $cyan-800;
    border-width: 2px;
  }
  &:has(.dp-accordion__button:focus-visible) .dp-accordion__button {
    outline: none;
  }

  &__button {
    color: $primary;

    &:hover,
    &:active,
    &.focus {
      color: $primary;
      text-decoration: none;
    }

    &:focus {
      color: $primary;
      box-shadow: none;
    }
  }

  &__title {
    font-size: 1rem;
    line-height: 1.5;
  }

  &__chevron {
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease-in-out;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__body {
    color: $neutral-700;
    font-size: 1rem;
    line-height: 24px;
  }
}
</style>
